import { type TouchEvent, useEffect, useMemo } from "react";
import type { PressHandlers } from "web_myplann/Shared/Types/PressHandlers";
import { createHoldRepeat } from "web_myplann/Shared/Utils/createHoldRepeat";

type Params = {
	startDelayMs: number;
	intervalMs: number;
	minIntervalMs?: number;
	accelerationMs?: number;
};

export const useHoldRepeat = ({
	startDelayMs,
	intervalMs,
	minIntervalMs,
	accelerationMs,
}: Params) => {
	const holdRepeat = useMemo(
		() =>
			createHoldRepeat({
				startDelayMs,
				intervalMs,
				minIntervalMs,
				accelerationMs,
			}),
		[startDelayMs, intervalMs, minIntervalMs, accelerationMs],
	);

	useEffect(() => holdRepeat.stop, [holdRepeat]);

	const pressHandlers = (onStep: () => void): PressHandlers => ({
		onMouseDown: () => holdRepeat.startFromMouse(onStep),
		onTouchStart: (event: TouchEvent) => {
			event.preventDefault();
			holdRepeat.startFromTouch(onStep);
		},
		onMouseUp: holdRepeat.stop,
		onMouseLeave: holdRepeat.stop,
		onTouchEnd: holdRepeat.stop,
		onTouchCancel: holdRepeat.stop,
	});

	return { pressHandlers };
};
